import { getToken, implicitRefresh, redirectToLogin } from 'colleague-auth'

const Console = console

const getAuthHeaders = () => {
  const token = getToken()
  if (token) {
    return {
      Authorization: `Bearer ${token.id_token}`,
      GraphAccessToken: token.access_token
    }
  }
  return {}
}

const createRequest = (endpoint,
  { body, method = 'GET', headers = { 'Content-Type': 'application/json' }, mode = 'cors', encType = null }) =>
  fetch(endpoint, {
    body,
    method,
    encType,
    mode,
    headers: {
      pragma: 'no-cache',
      'cache-control': 'no-cache',
      ...getAuthHeaders(),
      ...headers
    }
  })

const fetchRequest = (url, requestOptions = {}) =>
  createRequest(url, requestOptions)
    .then((response) => {
      if (response.status === 401) {
        return implicitRefresh()
          .then(() => createRequest(url, requestOptions)
            .then((retryResponse) => {
              if (retryResponse.status === 401 || retryResponse.status === 403) {
                redirectToLogin()
              }
              return retryResponse
            })
          )
          .catch((error) => {
            Console.log('Error on implicitRefresh')
            Console.log(error)
            redirectToLogin()
          })
      }
      return response
    })


export default fetchRequest


// WEBPACK FOOTER //
// ./src/utils/fetchAuth.js